module.exports = __webpack_public_path__ + "img/zuobiao.df863a04.svg";